export const en = {
  deliveryPickUpTime: "Pickup Time",
  deliveryTargetTime: "Delivery Time",
  from: "From",
  to: "To",
  status: "Status",
  actions: "Actions",
  auth: {
    alreadyHaveAccount: "Already have an account?",
    email: "Email",
    password: "Password",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    loginDescription: "Welcome back! Log in to manage your deliveries and profile.",
    loggingIn: "Logging in...",
    continueWithGoogle: "Continue with Google",
    or: "OR",
    noAccount: "Don't have an account?",
    signUp: "Sign Up",
    backToHome: "Back to Home",
      createAccount: "Create an account",
      createAccountDesc: "Join and start sending packages",
      creatingAccount: "Creating account...",
      confirmPassword: "Confirm password",
      passwordHelper: "At least 6 characters",
      acceptTerms: "I accept the ",
      termsOfService: "terms of service",
      organizationInvite: "Organization invitation",
      inviteMessage: "You've been invited to join:",
      loadingOrganizationInfo: "Loading organization information...",
      accountCreationFailed: "Failed to create account.",
    error: {
      passwordTooShort: "Password must be at least 6 characters long",
      loginFailed: "Login failed. Please check your credentials and try again.",
      googleLoginFailed: "Google login failed. Please try again.",
      unknownError: "An unexpected error occurred. Please try again.",
      organizationInfoNotFound: "Organization information not found.",
      organizationInfoFetchFailed: "Failed to fetch organization information.",
      emailRequired: "Email is required.",
      invalidEmail: "Invalid email address.",
      passwordMismatch: "Passwords do not match.",
      acceptTerms: "You must accept the terms of service.",
      accountCreationFailed: "Failed to create account.",
    },
  },
  header: {
    appName: "PH",
    activity: "Deliveries",
    sendPackage: "Send",
    deliverPackage: "Deliver",
    carry: 'Drive',
    organisation: 'Organization',
    payments: "Payments",
    profile: "Profile",
    myDeliveries: "My deliveries",
    settings: "Settings",
    logout: "Log out",
    login: "Log in",
    signup: "Sign up",
    info: "Info",
  },
  delivery: {
    courier: "Courier",
    segments: "segments",
    routeSteps: "Transport steps",
    changeBusOption: "Change bus option",
    busStep: "Bus segment",
    waitStep: "Bus transfer",
    carStep: "Car segment",
    busRoute: "Bus route",
    car: "Car",
    carDesc: "Direct courier delivery by car",
    publicTransport: "Public transport",
    publicTransportDesc: "Delivery via bus or train",
    selectAddressesToSeeOptions: "Select addresses to see delivery options",
    noOptionsAvailable: "No delivery options available for this route",
    selectBasicOption: "Select basic delivery option",
    selectFastOption: "Select fast delivery option",
    notSet: "Not set",

    // bus
    updateBusSchedule: "Update bus schedule",
    // packaging
    needPackaging: "Do you need packaging materials?",
    packagingUpsell: "Order packaging materials for your products at a low cost.",

    // Billing Section
    billingInfo: "Billing information",

    paymentMethod: "Payment method",
    invoice: "Invoice",
    invoiceDescription: "Pay later by invoice",
    card: "Card",
    cardDescription: "Pay immediately by card",
    yNumber: "Business ID",
    yNumberHelper: "Optional - Finnish business ID",
    companyName: "Company name",
    companyNamePlaceholder: "Company Ltd",
    companyNameHelper: "Optional",
    paymentReference: "Payment reference",
    paymentReferencePlaceholder: "Reference number or project code",
    paymentReferenceHelper: "Optional - for internal tracking",
    billingDepartment: "Cost center",
    billingDepartmentPlaceholder: "Department name or cost center",
    billingDepartmentHelper: "Optional",
    cardPaymentNote:
      "Payment will be processed after the delivery is submitted. You will be redirected to the payment page.",

    payNow: "Pay now",
    payForDelivery: "Pay for delivery",
    paymentRequired: "Payment required",
    paymentSuccessful: "Payment successful!",
    paymentFailed: "Payment failed. Please try again.",
    noOptionsSelected: "No special options selected",

    selectOptions: "Select additional options",
    billingAndOptions: "Billing and additional options",
    "eco-bus": "Bus parcel",
    "eco-regular": "Standard parcel",

    timing: "Pickup and delivery time",
    locations: "Pickup and delivery location",
    people: "Sender and recipient",
    returnParcel: "Return link",
    prePaid: "Prepaid",
    packageInfo: "Package information",
    billing: "Billing",
    total: "Total",
    sender: "Sender",
    recipient: "Recipient",
    delivery: "Delivery",
    reviewDelivery: "Review shipment",
    reviewDescription: "Make sure the shipment details are correct",
    confirmAndPay: "Confirm and send",
    packageCategory: "Size category",
    selectItems: "Select items",
    selectPackageItems: "Shipment definition",
    items: "items",
    kg: "kg",
    route: "Route",
    origin: "Origin",
    destination: "Destination",
    originHelp: "Pickup location for your package",
    labelsInfo:
      "Print shipping labels and attach them to the packages before pickup.",
    selectProductsForLabels: "Select the package you want to print labels for",
    printLabelsSubtitle: "Select a package and print address labels",
    printLabels: "Print Labels",
    pickupNow: "Available immediately",
    pickupDate: "Pickup date",
    today: "Today",
    tomorrow: "Tomorrow",

    pickupTimeModal: {
      title: "Pickup time",
      time: "Pickup time",
    },

    express: "Express",
    expressDesc: "Fastest available delivery",
    ecoBus: "Bus parcel",
    fast: "Fast",
    fastDesc: "Fast delivery service",
    eco: "Eco",
    ecoDesc: "Most affordable option - flexible delivery",

    standard: "1-5 days",
    custom: "Custom",
    any: "No delivery time preference",
    from: "Origin",
    to: "Destination",
    bustransport: "Bus transport",
    noDeliveries: "No deliveries yet",
    printWaybill: "Print waybill",
    resend: "Resend",
    waybillPrinted: "Waybill downloaded successfully",

    status: {
      active: "Active",
      ongoing: "Courier found",
      accepted: "Accepted",
      picked: "Picked up",
      completed: "Completed",
      cancelled: "Cancelled",
    },

    // Page title
    sendPackage: "Send",
    deliverPackage: "Deliver",

    // Location fields
    pickup: "Pickup",
    dropoff: "Delivery",

    // Package size
    selectPackageSize: "Select size",
    size: "Size",
    small: "Small (0–20 kg)",
    medium: "Medium (20–30 kg)",
    large: "Large (30–90 kg)",
    xl: "Extra large (90+ kg)",

    // Weight
    weight: "Weight (kg)",

    // Details
    moreDetails: "More details",
    detailsTitle: "📋 Additional details",

    // Distance and duration
    distance: "Distance (km)",
    duration: "Duration (min)",
    distanceWithDuration: " km • min",

    // Buttons and actions
    createDelivery: "Continue",
    createDeliveryWithPrice: "Create shipment • {{price}}€",
    create: "Create",
    creating: "Creating...",
    creatingDelivery: "Creating...",

    // Estimate
    estimate: "Estimate",
    estimatedPrice: "Estimated Price",
    startingFrom: "Starting from",
    totalPrice: "Total Price",
    free: "Free",
    vat: "+ VAT",

    // Delivery options
    deliveryOptions: "Delivery options",
    calculatingRates: "Calculating rates...",
    enterAddressesPrompt:
      "Enter pickup and delivery addresses to see options",

    // Main delivery types
    startingFrom: "Starting from",
    earliestDelivery: "Earliest possible delivery",

    // Option types
    busparcel: "Bus parcel",
    busparcelDesc: "Bus parcel - click to select",
    customDesc: "Set your own price",
    customPriceLabel: "Custom price (€)",

    "eco-bus": "Bus parcel",

    // Eco menu
    selectEcoOption: "Select transport mode",
    busTransport: "Bus transport",
    busTransportDesc: "Delivery via public transport network",
    regular: "Standard",
    regularDesc: "Regular parcel delivery",
    bid: "Bid",
    bidDesc: "Set your own price - not guaranteed",

    // Standard delivery
    regularOptions: "Standard delivery options",
    pickupLocation: "Pickup",
    deliveryLocation: "Delivery",
    parcelCenter: "Parcel point",
    homePickup: "Home pickup",
    homeDelivery: "Home delivery",
    free: "Free",
    totalPrice: "Total price",

    // Bid
    bidTitle: "Set your bid",
    bidWarning:
      "Note: match your bid to the delivery schedule and distance. A bid that is too low may result in no courier being found for your delivery.",
    yourPrice: "Your price",
    priceLabel: "Price (€)",
    pickupTime: "Available from",
    latestPickupTime: "Latest pickup time",
    latestPickUpHelp: "Optional: set the latest pickup time",
    targetTime: "Delivered by",
    earliestTargetTime: "Earliest deliverable time",
    earliestPickupTime: "Earliest pickup time",
    latestPickup: "Latest pickup",
    latestTargetTime: "Latest delivery time",
    hideTimeWindow: "Cancel definition",
    setTimeWindow: "Refine time window",
    date: "Date",
    time: "Pickup and delivery time",

    // Special options
    specialOptions: "Special options",
    returnParcels: "Parcel return",
    returnMethod: "Return method",
    returnByBus: "Bus",
    returnByPost: "Post",
    returnParcelsDesc: "Shipment returns to sender after delivery",
    temperatureControl: "Temperature control",
    temperatureControlDesc: "Requires temperature monitoring",
    canBeLeftAtDoor: "Contactless delivery",
    canBeLeftAtDoorDesc: "Package can be left at the recipient's door",
    requiresPin: "Requires PIN",
    requiresPinDesc: "Recipient must provide a PIN to receive the delivery",
    requiresSignature: "Requires signature",
    requiresSignatureDesc: "Recipient must sign for the delivery",

    // My deliveries
    sendNew: "Create shipment",
    myDeliveries: "My shipments",
    resendNotification:
      "Transport information loaded. Update and create a new shipment.",

    // Pickup and delivery sections
    pickupDetails: "Pickup details",
    deliveryDetails: "Delivery details",
    addressDetails: "Address details",
    optional: "(Optional)",
    senderInformation: "Sender information",
    recipientInformation: "Recipient information",
    notSelected: "Not selected",

    // Time
    timeWindow: "Time",
    target: "Target time",
    timeWindowPriceNote: "Setting a time window adds €4 + VAT",

    // VAT
    vat: "incl. VAT",

    // Sender/Recipient
    senderName: "Sender name",
    senderPhone: "Sender phone number",
    senderEmail: "Sender email address",
    recipientName: "Recipient name",
    recipientPhone: "Recipient phone number",
    recipientEmail: "Recipient email address",

    editDetailsDescription: "Edit details",
    selected: "Selected",
    printSelected: "Save waybills",
    price: "Price",
    company: "Company",

    // Form fields
    form: {
      apartmentNumber: "Apartment number",
      apartmentPlaceholder: "e.g. 12B",
      floor: "Floor",
      floorPlaceholder: "e.g. 3rd floor",
      buildingName: "Building name",
      buildingPlaceholder: "e.g. Building A",
      accessCode: "Access code",
      accessCodePlaceholder: "e.g. #1234*",
      pickupInstructions: "Pickup instructions",
      pickupInstructionsPlaceholder:
        "Leave package at reception, ring doorbell twice, etc.",
      deliveryInstructions: "Delivery instructions",
      deliveryInstructionsPlaceholder: "Leave at door, call upon arrival, etc.",
      name: "Name",
      senderNamePlaceholder: "Sender's name",
      recipientNamePlaceholder: "Recipient's name",
      phone: "Phone number",
      phonePlaceholder: "+1 234 567 8900",
      email: "Email",
      emailPlaceholder: "example@email.com",
    },

    // Error messages
    errors: {
      selectAddresses: "Please select pickup and delivery addresses.",
      selectOption: "Please select a delivery option.",
      createFailed: "Failed to create shipment.",
      waybillPrintFailed: "Failed to print waybill.",
    },

    // Success messages
    success: {
      created: "Shipment created successfully!",
    },

    // Size categories
    small: "Small parcel",
    medium: "Medium",
    large: "Large",
    extraLarge: "Extra large",

    // Technical details
    specifications: "Specifications",
    maxDimensions: "Maximum dimensions",

    // Items
    items: "Items",
    item: "Item",
    addItem: "Add item",

    // Dimensions
    length: "Length (cm)",
    width: "Width (cm)",
    height: "Height (cm)",

    // Size descriptions
    sizeDescriptions: {
      small: {
        example: "Easy to carry by hand",
        description: "Letters, documents, small packages",
      },
      medium: {
        example: "Fits in a car trunk",
        description: "Medium-sized boxes, sports equipment",
      },
      large: {
        example: "Fits in a van",
        description: "Large boxes, furniture",
      },
      extraLarge: {
        example: "Requires a truck",
        description: "Home appliances, large furniture",
      },
    },

    busTransportModal: {
      // Time
      timePickerHint: "You can find a departure time that suits you.",
      waitTime: "Waiting time at bus stop",
      title: "Bus parcel",
      departureTime: "Departure time",
      deliveryOptions: "Delivery options",
      includeFirstMile: "Home pickup to bus stop",
      includeLastMile: "Delivery from bus stop to recipient",

      // Warnings
      bothSelfService:
        "You must drop off the package at the departure station and the recipient must collect it from the arrival station.",
      firstMileSelfService: "You must drop off the package at the departure station yourself.",
      lastMileSelfService:
        "The recipient must collect the package from the arrival station.",

      // Step titles
      selfService: "Self",
      selfTransport: "Self transport",
      carTransport: "Car transport",
      busTrip: "Bus trip",
      busSegment: "Bus",
      carSegment: "Car",

      // Route info
      route: "Route",
      from: "Origin",
      to: "Destination",
      distance: "Distance",
      duration: "Duration",
      steps: "steps",
      busChange: "Bus transfer",
      busTransport: "Bus transport",
      availableOptions: "Available options",
      noOptions: "No bus options available for this route.",

      // Summary
      price: "Price",
      routeSteps: "Route steps",
      priceBreakdown: "Price breakdown",
      departure: "Departure",
      arrival: "Arrival",
      specifications: "Details",

      // Actions
      select: "Select bus parcel",
      selectTime: "Select time",

      // Errors
      fetchError: "Could not fetch bus connections",
      generalError: "Error fetching bus options",

      // buses
      showRoute: "Show route",
      hideRoute: "Hide route",
      customRoute: "Edit route",
      editable: "Editable",
      invalidRoute: "Route is not valid",
      addStepAtStart: "Add step at start",
      addStepAfter: "Add step after",
      editRoute: "Edit route",
      addStep: "Add step",
      editStep: "Edit step",
      editBusChange: "Edit bus transfer",
      waitTimeMinutes: "Wait time (min)",
      routeNumber: "Line number",
      company: "Company",
      firstMile: "Pickup",
      lastMile: "Delivery",
      firstMileDesc: "Transport from home to bus station",
      busSegmentDesc: "Bus journey between two stations",
      busChangeDesc: "Waiting time at station",
      lastMileDesc: "Transport from bus station to recipient",
      noAvailableSteps: "No steps available to add",
    },
  },

  payment: {
    completePayment: "Complete payment",
    amountToPay: "Amount to pay",
    enterPaymentDetails: "Choose a payment method and enter your details",
    enterCardDetails: "Enter your card details",
    choosePaymentMethod: "Choose how you would like to pay",
    cardTitle: "Card",
    cardDescription: "Pay securely by credit or debit card with Stripe",
    cryptoTitle: "Cryptocurrency",
    cryptoMethodDescription: "Choose a cryptocurrency and pay with NOWPayments",
    cryptoDescription: "You will be taken to NOWPayments to choose a cryptocurrency and complete the payment.",
    continueToCryptoPayment: "Continue to crypto payment",
    reopenCryptoPayment: "Reopen payment page",
    cryptoWaiting: "Waiting for the payment to be completed…",
    cryptoConfirming: "Waiting for blockchain confirmation…",
    cryptoConfirmed: "Payment confirmed!",
    cryptoExpired: "This payment has expired. Please start again.",
    cryptoFailed: "The payment failed. Please try again.",
    payAmount: "Pay {{amount}} €",
    initializationFailed: "Payment initialization failed",
    processingPayment: "Processing payment...",
  },

  terms: {
    title: "Terms of Sale",
    lastUpdated: "Last updated",
    footer: {
      rights: "All rights reserved.",
      payment: "Payment",
      withdrawal: "Right of withdrawal",
      returns: "Returns",
      complaints: "Complaints",
    },
  },

  processing: "Processing...",

  filters: {
    all: "All",
    location: "Location",
    category: "Category",
    subcategory: "Subcategory",
    sort: "Sort",
    price: "Price",
  },

  common: {
    apply: "Done",
    reset: "Cancel",
    done: "Done",
    total: "Total",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    confirm: "Select",
    back: "Back",
    next: "Next",
    submit: "Continue",
    loading: "Loading...",
    error: "Error",
    success: "Success",
  },

  user: {
    title: "My Account",
    subtitle:
      "Manage your personal information, billing, and organization settings",
    loading: "Loading account...",
    tabs: {
      profile: "Profile",
      billing: "Billing",
      organization: "Organization",
    },
  },

  profile: {
    title: "My Profile",
    subtitle: "Manage your personal information and account settings",
    loading: "Loading profile...",
    editButton: "Edit Profile",
    saveButton: "Save Changes",
    cancelButton: "Cancel",
    updateSuccess: "Profile updated successfully",
    updateError: "Failed to update profile. Please try again.",

    fields: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email address",
      phone: "Phone number",
      phonePlaceholder: "+1 234 567 8900",
      mode: "User mode",
      optional: "Optional",
    },

    mode: {
      none: "Not selected",
      sender: "Sender",
      courier: "Courier",
    },

    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailRequired: "Email is required",
      invalidEmail: "Please enter a valid email address",
      invalidPhone: "Please enter a valid phone number",
    },

    accountInfo: {
      title: "Account Information",
      userId: "User ID",
      postalCode: "Postal code",
      notSet: "Not set",
      roles: "Roles",
    },
  },

  billing: {
    title: "Billing Information",
    subtitle: "Manage company information for billing purposes",
    editButton: "Edit billing information",
    saveButton: "Save changes",
    cancelButton: "Cancel",
    updateSuccess: "Billing information updated successfully",
    updateError: "Failed to update billing information. Please try again.",

    billingInfo: {
      title: "Billing information",
    },

    paymentInfo: {
      title: "Payment information",
      subtitle: "Information for receiving delivery compensation",
    },

    fields: {
      yNumber: "Business ID",
      companyName: "Company name",
      billingMethod: "Billing method",
      billingFrequency: "Billing frequency",
      billingFrequencyHelp: "Fixed billing period",
      paymentYNumber: "Payee business ID",
      paymentCompanyName: "Company name",
      iban: "IBAN",
    },

    billingMethod: {
      invoice: "Invoice",
      card: "Card",
    },

    validation: {
      yNumberRequired: "Business ID is required",
      companyNameRequired: "Company name is required",
      paymentYNumberRequired: "Payment business ID is required",
      paymentCompanyNameRequired: "Payment company name is required",
      ibanRequired: "IBAN is required",
      invalidIban: "Invalid IBAN format",
    },

    summary: {
      title: "Billing summary",
      billingEntity: "Billing entity",
      billingMethod: "Billing method",
      paymentEntity: "Payment recipient",
      billingFrequency: "Billing frequency",
      every7Days: "Every 7 days",
    },
  },

  organization: {
    tabs: {
      info: "Information",
      deliveries: "Deliveries",
    },
    title: "Organization",
    subtitle: "Manage your organization and team members",
    editButton: "Edit Organization",
    createButton: "Create Organization",
    saveButton: "Save Changes",
    createAndSaveButton: "Create organization",
    cancelButton: "Cancel",
    updateSuccess: "Organization updated successfully",
    updateError: "Failed to update organization. Please try again.",

    noOrganization: "No organization",
    createPrompt: "Create an organization to manage members",
    memberView: "Member",
    readOnlyNotice: "Only the organization owner can edit this information",
    inviteLinkCopied: "Invite link copied to clipboard",
    copyFailed: "Failed to copy invite link",
    memberRemoved: "Member removed successfully",
    removeMemberError: "Failed to remove member",

    member: "member",
    members: "members",

    fields: {
      name: "Organization name",
      organizationName: "Organization Name",
      organizationNamePlaceholder: "Your organization",
      description: "Description",
      descriptionPlaceholder: "Describe what your organization does...",
      email: "Email",
      phone: "Phone",
      postalCode: "Postal code",
      locationPostalCode: "Location postal code",
      locationAddress: "Address",
      address: "Address",
      addressPlaceholder: "Street address",
      optional: "Optional",
    },

    location: {
      title: "Location",
      subtitle: "Optional location information for the organization",
    },

    validation: {
      nameRequired: "Organization name is required",
    },

    roles: {
      owner: "Owner",
      admin: "Admin",
      member: "Member",
    },

    invite: {
      title: "Invite members",
      description: "Share this link to invite users to your organization",
      copy: "Copy invite link",
      copied: "Copied!",
    },

    members: {
      title: "Members",
      description: "Manage organization members",
      unnamed: "Unnamed member",
      you: "You",
      remove: "Remove member",
      copyUid: "Copy UID",
      uidCopied: "UID copied to clipboard",
      addButton: "Add Member",
      table: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        actions: "Actions",
      },
      removeDialog: {
        title: "Remove member",
        description: "Are you sure you want to remove {{name}} from the organization?",
        confirm: "Remove",
        cancel: "Cancel",
      },
    },

    addMember: {
      title: "Add existing user",
      description: "Add a user who already has an account by entering their user ID (UID)",
      uidPlaceholder: "Enter user UID...",
      helperText: "You can find the user's UID in their profile or account settings",
      button: "Add member",
      uidRequired: "User ID is required",
      alreadyMember: "User is already a member of the organization",
      success: "Member added successfully",
      error: "Failed to add member. Check the UID and try again.",
    },

    deleteDialog: {
      title: "Remove team member",
      description: "Are you sure you want to remove {{name}} from the organization?",
      cancel: "Cancel",
      confirm: "Remove",
    },

    info: {
      title: "Organization information",
      name: "Name",
      description: "Description",
      members: "Members",
      location: "Location",
    },

    deliveries: {
      title: "Organization Deliveries",
      subtitle: "View and manage all deliveries completed by your organization",
      ownerOnly: "Only organization owners can view deliveries",
      membersOnly: "Only organization members can view deliveries",
      loadError: "Failed to load deliveries",
      noDeliveries: "No deliveries yet",
      noResults: "No deliveries match your search",
      search: "Search by ID, sender, courier, or location...",
      sortBy: "Sort by",
      order: "Order",
      export: "Export to CSV",
      rowsPerPage: "Rows per page",
      stats: {
        total: "Total Deliveries",
        revenue: "Total Revenue",
        couriers: "Unique Couriers",
      },
      sortOptions: {
        date: "Date",
        price: "Price",
        sender: "Sender",
        courier: "Courier",
      },
      orderOptions: {
        asc: "Ascending",
        desc: "Descending",
      },
      table: {
        id: "Delivery ID",
        date: "Completed",
        sender: "Sender",
        courier: "Courier",
        route: "Route",
        price: "Price",
        reward: "Reward",
      },
    },
  },
  drive: {
    transportModal: {
      title: "Select transport mode",
      options: {
        all: "All",
        wait: "Bus transfer",
        express: "Passenger car",
        van: "Van",
      },
    },
    locationModal: {
      title: "Update location",
      description: "Deliveries are filtered based on your location.",
      label: "City or address",
      placeholder: "e.g. Helsinki",
      currentLocation: "Your location",
      locating: "Finding location…",
      useCurrentLocation: "Use current location",
    },
    reportProblem: {
      title: "Report a problem",
      description: "Select the problem type and add details if needed.",
      detailsLabel: "Additional details (optional)",
      detailsPlaceholder: "Describe what happened…",
      revertLabel: "Cancel delivery and release it to others",
      revertDescription: "Use this if you cannot complete the delivery",
      revertWarning: "The delivery will return to Available status. A valid reason is required, otherwise a cancellation fee may apply.",
      urgentHelp: "For urgent cases, call +358 50 505 8167",
      submitting: "Sending…",
      submit: "Send report",
      revertAndSubmit: "Cancel and send report",
      issues: {
        not_found: "I cannot find the package",
        address_wrong: "The address is incorrect",
        recipient_unreachable: "The recipient cannot be reached",
        package_damaged: "The package is damaged",
        bus_issue: "Problem with bus transport",
        other: "Other",
      },
    },
  },
  "downloadApp": {
  "title": "Pakettihuolto app",
  "subtitle": "The courier app for Android phones",
  "download": "Download the app",
  "preparing": "Preparing download…",
  "versionInfo": "Version {{version}} · Android 8.0 or newer",
  "stepsTitle": "Getting started",
  "unknownSources": "If the installation doesn't start, allow installs from unknown sources in your phone's settings for the app you opened the file from (usually Chrome or Files).",
  "support": "Trouble installing? Contact tuki@pakettihuolto.fi",
  "error": {
    "urlFailed": "Couldn't fetch the download link. Please try again in a moment."
  },
  "notice": {
    "ios": "The app only works on Android phones. On iPhone, use pakettihuolto.fi in your browser.",
    "desktop": "Open this page on your Android phone to install the app."
  },
  "steps": {
    "download": {
        "title": "Download the app",
        "body": "Tap the download button above to get the APK file."
      },
      "install": {
        "title": "Open the file and tap Install",
        "body": "Open the downloaded APK from your notifications or Files app. When Android asks if you want to install the app, tap Install."
      },
      "playProtect": {
        "title": "Allow the install if Play Protect warns you",
        "body": "Because the app isn't from Google Play, a warning may appear. Tap \"More details\" and then \"Install anyway\" to continue."
      },
    "login": {
      "title": "Log in",
      "body": "Use the same credentials as on pakettihuolto.fi."
    },
    "deliveries": {
      "title": "See your deliveries",
      "body": "Deliveries assigned to you appear on the Lobby tab."
    }
  }
}
};
